import React, { Fragment } from 'react';

import Separator from '../Separator';
import CommentValue from './CommentValue';

export interface CommentSectionProps {
  value: string;
}

const CommentSection = ({ value }: CommentSectionProps) =>
  value !== '' && (
    <Fragment>
      <Separator />
      <CommentValue data-testid="comment">{value}</CommentValue>
    </Fragment>
  );

export default CommentSection;
